import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { Classes, Dialog } from '@blueprintjs/core';
import { AppStore } from '../../stores/AppStore';
import { MDBRow, MDBBtn } from "mdbreact";
import { NotificacoesStore } from '../../stores/notificacoes/NotificacoesStore';
import { IconButton } from '@mui/material';
import { LegislacaoStore } from '../../stores/legislacao/LegislacaoStore';
import { AppIcon } from '../utils/AppIcon';

interface State {
  isTourOpen: boolean,
  isShowingMore: boolean,
  menuItems: MenuItem[];
}

type MenuItem = {
  label: string;
  path: string;
  icon: JSX.Element;
};

@observer
export class DashboardUserPage extends React.Component<{}, State> {

  obs = observable({
    open_visualiza_descricao: false as boolean,
    description: "" as string,
  })

  constructor(props: any) {
    super(props);

    this.state = {
      isTourOpen: false,
      isShowingMore: false,
      menuItems: []
    };

  }

  async componentDidMount() {

    AppStore.setTitle("");

    await NotificacoesStore.handleConsultaWarnings();

    if (NotificacoesStore.obs.warnings.length >= 1) {
      NotificacoesStore.obs.isTourOpen = true
    }

    if (AppStore.obs1.usuario && AppStore.obs1.releases.length) {

      if (!AppStore.obs1.usuario.version_update || AppStore.obs1.usuario.version_update != AppStore.obs1.releases[0].version) {

        this.obs.open_visualiza_descricao = true
        this.obs.description = AppStore.obs1.releases[0].description

      }

    }

  }

  formatVersion = (version) => {

    return parseInt(version.replace(/\./g, ""))

  }

  async handleEntendi() {

    this.obs.open_visualiza_descricao = false

    if (!AppStore.obs1.usuario.version_update || this.formatVersion(AppStore.obs1.releases[0].version) > this.formatVersion(AppStore.obs1.usuario.version_update)) {

      await AppStore.handleUpdatesModal(AppStore.obs1.usuario._id, AppStore.obs1.releases[0].version)

      if (AppStore.obs1.result_ok) {

        await AppStore.loadUsuario()

      }

    }

  }

  async handleLocator(path) {

    if (path == "/calculo-icms") {

      await LegislacaoStore.get_pdf("icms")
      return

    }

    if (path == "/decreto-icms") {

      await LegislacaoStore.get_pdf("decreto")
      return

    }

    AppStore.setLocation(path)

  }

  render() {

    const permissoesRotas = [
      { id: "pgdas", label: "PGDAS", path: "/pgdas", iconName: "savings" },
      { id: "sped", label: "SPED", path: "/sped", iconName: "description" },
      { id: "fgts", label: "FGTS DIGITAL", path: "/fgts-digital", iconName: "engineering" },
      { id: "dei", label: "DEI", path: "/dei", iconName: "assignment" },
      { id: "importacao", label: "IMPORTAÇÃO DE XMLS", path: "/imports", iconName: "upload_file" },
      { id: "xml_integracao", label: "XML INTEGRAÇÃO", path: "/xml-integration", iconName: "code" },
      { id: "manifestacao", label: "MANIFESTAÇÃO", path: "/historico-notas", iconName: "manage_search" },
      { id: "notas_xml", label: "NF-E | NFC-E | CT-E | NFS-E", path: "/nfes", iconName: "integration_instructions" },
      { id: "nfe_fazenda", label: "Portal da NF-e", path: "/portal-nfe", iconName: "support_agent" },
      { id: "sefa", label: "SOLICITAÇÕES SEFA", path: "/solicitacoes-sefa", iconName: "support_agent" },
      { id: "prefeitura", label: "PREFEITURA", path: "/nfse-prefeitura", iconName: "home_work" },
      { id: "memoria_calculos", label: "MEMÓRIA DE CALCULOS", path: "/memoria-calculo", iconName: "memory" },
      { id: "resultados_calculos", label: "RESULTADOS DE CALCULOS", path: "/resultados", iconName: "calculate" },
      { id: "legislacoes", label: "CALCULO ICMS", path: "/calculo-icms", iconName: "download" },
      { id: "legislacoes", label: "DECRETO ICMS", path: "/decreto-icms", iconName: "download" },
      { id: "legislacoes", label: "ALÍQUOTAS DE ICMS", path: "/icms-aliquotas", iconName: "percent" },
      { id: "legislacoes", label: "CNAE", path: "/cnae", iconName: "production_quantity_limits" },
      { id: "legislacoes", label: "CST - ORIGEM", path: "/cst-origem", iconName: "settings_suggest" },
      { id: "legislacoes", label: "CST - CSON/ICMS", path: "/cst-cson", iconName: "edit" },
      { id: "legislacoes", label: "CST - PIS/COFINS", path: "/pis-cofins", iconName: "monetization_on" },
      { id: "legislacoes", label: "EANS", path: "/eans", iconName: "barcode" },
      { id: "legislacoes", label: "TIPI", path: "/tipi", iconName: "table_chart" },
      { id: "legislacoes", label: "MVAS - PA", path: "/mvas-pa", iconName: "report_problem" },
      { id: "legislacoes", label: "MVAS - RS", path: "/mvas-rs", iconName: "report_problem" },
      { id: "legislacoes", label: "MONOFÁSICO", path: "/monofasico-simples", iconName: "difference" },
      { id: "legislacoes", label: "TRIBUTAÇÃO NACIONAL", path: "/tributacao-nacional", iconName: "attach_money" },
      { id: "legislacoes", label: "CFOPS", path: "/cfops", iconName: "numbers" },
      { id: "relatorios", label: "Clientes", path: "/clientes", iconName: "groups" },
      { id: "relatorios", label: "Fornecedores", path: "/fornecedores", iconName: "local_shipping" },
      { id: "relatorios", label: "SPED para XLSX", path: "/sped-planilha", iconName: "table_view" },
      { id: "relatorios", label: "XLSX para SPED", path: "/sped-txt", iconName: "article" },
      { id: "relatorios", label: "RELATÓRIO GERAL", path: "/relatorios", iconName: "analytics" },
      { id: "relatorios", label: "Relatório de parcelamentos ", path: "/relatorio_parcelamento", iconName: "receipt_long" },
      { id: "relatorios", label: "Configuração de Token", path: "/integracoes", iconName: "vpn_key" },
      { id: "relatorios", label: "Confirmação de Chave e Tokens", path: "/confirmacao-chaves-tokens", iconName: "verified_user" },
      { id: "relatorios", label: "Faixa Simples Nacional", path: "/faixa-simples", iconName: "request_quote" },
      { id: "relatorios", label: "Relatório de Cálculo de Manifestação", path: "/calculo-manifestacao", iconName: "summarize" },
      { id: "cnds", label: "CNDS", path: "/cnds", iconName: "workspace_premium" },
      { id: "sitfis", label: "SITUAÇÃO FISCAL (RFB)", path: "/sitfis", iconName: "account_balance" },
      { id: "dec_sefa", label: "DEC SEFA", path: "/dec-sefa", iconName: "mark_email_unread" },
      { id: "caixa_postal", label: "CAIXA POSTAL", path: "/caixa-postal", iconName: "inbox" },
      { id: "classificacao", label: "CLASSIFICAÇÃO", path: "/classificacao", iconName: "account_tree" },
      { id: "bots", label: "Gerenciamento de Tarefas", path: "/tarefas", iconName: "task_alt" },
      { id: "parcelamentos", label: "PARCELAMENTOS", path: "/parcelamentos", iconName: "payments" },
      { id: "logs", label: "LOGS", path: "/logs", iconName: "history" },
      { id: "erros_calculos", label: "Erros de Cálculo", path: "/erros-notas", iconName: "error_outline" },
      { id: "det", label: "DET", path: "/det", iconName: "mark_email_read" },
      { id: "api", label: "Histórico de Atualizações", path: "/releases", iconName: "new_releases" },
    ];

    return (

      <div>

        <MDBRow>

          <div className="container-modulos" style={{ width: "100%", justifyContent: "center" }}>

            {permissoesRotas.map(({ id, label, path, iconName }) => {
              const permitido = AppStore.obs1.usuario.permissoes[id] || id === "api";

              return (
                <div
                  key={path}
                  onClick={() => this.handleLocator(path)}
                  className="itens-menu-fiscal"
                  style={{ position: "relative" }}
                >
                  <span className={`status-permissao ${permitido ? "permitido" : "negado"}`} title={
                    permitido
                      ? "Acesso liberado"
                      : "Sem permissão. Contate o usuário administrador."
                  } />

                  <div className="mb-2">
                    <AppIcon name={iconName} size={24} />
                  </div>

                  {label}
                </div>
              );
            })}

          </div>

        </MDBRow>

        <div style={{ marginTop: 5, marginBottom: 100 }}></div>

        <Dialog isOpen={this.obs.open_visualiza_descricao} onClose={() => this.obs.open_visualiza_descricao = false} className="modal-releases">

          <div className={Classes.DIALOG_CLOSE_BUTTON} style={{ textAlign: "right" }}>
            <IconButton onClick={() => AppStore.setLocation("/releases")}>
              <AppIcon name="arrow_forward" style={{ color: "#3579ea" }} />
            </IconButton>
          </div>

          <div style={{ padding: "0px 0px 15px 0px" }}>

            <div dangerouslySetInnerHTML={{ __html: this.obs.description }} />

          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <MDBBtn className="btnDefault" onClick={() => this.obs.open_visualiza_descricao = false}>Fechar</MDBBtn>
            &nbsp;&nbsp;
            <MDBBtn className="btnDefault btnNaoMostrar" onClick={() => this.handleEntendi()}>Entendi</MDBBtn>
          </div>

        </Dialog>

      </div>

    );
  }
}

export default DashboardUserPage;

